module.exports = __webpack_public_path__ + "img/167.acbdd6fa.png";